import { v4 as uuidv4 } from 'uuid';
import {
  distanceToInches,
  distanceToMillimeters, getFontsize, getFontsizeSmall, getIntersectCordsBetweenLines,
  getMidPoint,
  getPointDistance, isDisabledInPopupWithParents,
  measureDistanceToInches,
  orientation
} from "../../../../../helpers/sqftHelper";
import point from "../point";
import shapeLine from "../line";
import {getMaxResizeWidth} from "./resizeLine";
import COLOR_THEMES from "../../../store/colorThemes";
import Config from "../../../store/sqftConfig";
import configGlobal from "../../../store/sqftConfig";
import EventManager from "../../../store/sqftEventManager";
import {pnpolyArray} from "../../../../../lib/pnpoly";
import workspace from "../../workspace";
import $ from "jquery";
import store from "../../../../../../../store";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import sqftEventManager from "../../../store/sqftEventManager";
import {isDisabledInPopupShouldBeHidden, RESOURCE_TYPE} from "../../../../../constants";
import SqftStore from "../../../store/sqftStore";
import {renderResetSeamPopup, shouldResetSlabModePopupOnPointMoveBeDisplayed} from "../../../canvasPopup/resetSeam";
import {crossProduct2D} from "../../../../../helpers/coordinatesHelper";
import {getBumpoutFeature} from "../../../../../helpers/featureHelper";
import {createAdjustableInput} from "../../../../../helpers/uiHelper";
import {deleteResource} from "../../../../../../../actions/sqftResourceFunctions";

export default  function(resourceId) {
  var self = this,
    state = {
      mousePos: {},
      mouseDown: false,
      mouseDownPosition: null,
      isHoveringRect: false,
      isHoveringPoint: false,
      hoveredPoint: null,
      isHoveredOverText: false,
      hoveredText: {
        area:[],
        midPoint: {x: 0, y: 0},
        pointsDistance: 0,
        points: {point1: null, point2: null},
        orientation: 0
      },
      midPoint: {
        x: 0,
        y: 0,
      }
    },
    config = {
      initialSize: 30,
      minBumpoutSize: 1,
      dragPointMargin: 28,
      rulerMargin: 25,
      movePointOffset: 100,
      lineTextColor: COLOR_THEMES[Config.activeTheme].primary
    },
    bumpoutPoints = {
      point1: null,
      point2: null,
      point3: null,
      point4: null,
      dragPoint: null
    },
    bumpoutTextParameters = {
      lengthFrom1 : {
        area:[],
        midPoint: {x: 0, y: 0},
        pointsDistance: 0,
        points: {point1: null, point2: null},
        orientation: 0
      },
      length14 : {
        area:[],
        midPoint: {x: 0, y: 0},
        pointsDistance: 0,
        points: {point1: null, point2: null},
        orientation: 0
      },
      length34 : {
        area:[],
        midPoint: {x: 0, y: 0},
        pointsDistance: 0,
        points: {point1: null, point2: null},
        orientation: 0
      },
      length4to : {
        area:[],
        midPoint: {x: 0, y: 0},
        pointsDistance: 0,
        points: {point1: null, point2: null},
        orientation: 0
      },
    },
    deleteFillStyle = "rgba(253,2,33, 0.5)",
    line = null,
    bumpoutLines = null;

  this.id = uuidv4(); // sqftId (this is not attached resource id)
  this.resourceId = resourceId; // (this is attached resource id)
  this.featureId = null; // will be assigned on init

  console.log("resourceId", resourceId);
  debugger // eslint-disable-line no-debugger
  //private property setters
  function setLine(value) { line = value; }
  function setBumpoutPoints(value) { bumpoutPoints = value; }

  //private functions
  function preparePoints() {
    var midPoint = getMidPoint(line.from, line.to),
      point1,
      point2,
      point3,
      point4,
      dragPoint,
      dragPointMargin,
      flipPoints = false;

    const lineDirection = line.getLineDirection();

    switch (lineDirection.orientation) {
      case "horizontal": {
        flipPoints = lineDirection.newDirection === "west";
        dragPointMargin = flipPoints ? config.dragPointMargin : -config.dragPointMargin;
        point1 = new point(midPoint.x - config.initialSize / 2, midPoint.y, undefined, undefined, false);
        point2 = new point(midPoint.x - config.initialSize / 2, midPoint.y, undefined, undefined, false);
        point3 = new point(midPoint.x + config.initialSize / 2, midPoint.y, undefined, undefined, false);
        point4 = new point(midPoint.x + config.initialSize / 2, midPoint.y, undefined, undefined, false);
        dragPoint = new point(midPoint.x, midPoint.y + dragPointMargin, undefined, undefined, false);

        break;
      }
      case "vertical": {
        flipPoints = lineDirection.newDirection === "north";
        dragPointMargin = flipPoints ? -config.dragPointMargin : config.dragPointMargin;
        point1 = new point(midPoint.x, midPoint.y - config.initialSize / 2, undefined, undefined, false);
        point2 = new point(midPoint.x, midPoint.y - config.initialSize / 2, undefined, undefined, false);
        point3 = new point(midPoint.x, midPoint.y + config.initialSize / 2, undefined, undefined, false);
        point4 = new point(midPoint.x, midPoint.y + config.initialSize / 2, undefined, undefined, false);
        dragPoint = new point(midPoint.x + dragPointMargin, midPoint.y, undefined, undefined, false);
        break;
      }
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        //todo rotation
        point1 = new point(midPoint.x, midPoint.y - bumpoutPoints.initialSize / 2, undefined, undefined, false);
        point4 = new point(midPoint.x, midPoint.y + bumpoutPoints.initialSize / 2, undefined, undefined, false);
        dragPoint = new point(midPoint.x, midPoint.y, undefined, undefined, false);

        break;
      }
      default:
        break;
    }

    setBumpoutPoints ({
      point1: flipPoints ? point4 : point1,
      point2: flipPoints ? point3 : point2,
      point3: flipPoints ? point2 : point3,
      point4: flipPoints ? point1 : point4,
      dragPoint: dragPoint
    });
  }

  function movePointInOrStop(point1, point2, axis, diff, biggestPoint, smallestPoint, stopPoint) {
    // stop on other bumpout move point
    if (point1[axis] > stopPoint[axis]) {
      smallestPoint = stopPoint[axis] + config.minBumpoutSize;
    } else {
      biggestPoint = stopPoint[axis] - config.minBumpoutSize;
    }

    if (point1[axis] - diff >= biggestPoint) {
      point1[axis] = point2[axis] = biggestPoint;
    } else if (point1[axis] - diff <= smallestPoint) {
      point1[axis] = point2[axis] = smallestPoint;
    } else {
      point1[axis] -= diff;
      point2[axis] -= diff;
    }
  }

  function movePointOutOrStop(point1, point2, axis, diff, biggestPoint, smallestPoint) {
    let direction = line.getLineDirection().newDirection;
    let dragPointMargin;
    let lengthMidPoint;

    if (point1[axis] - diff > smallestPoint && (direction === "east" || direction === "north")) {
      dragPointMargin = -config.dragPointMargin;
      point1[axis] = point2[axis] = smallestPoint;
      bumpoutPoints.dragPoint[axis] = smallestPoint + dragPointMargin
    } else if (point1[axis] - diff < biggestPoint && (direction === "west" || direction === "south")) {
      dragPointMargin = +config.dragPointMargin;
      point1[axis] = point2[axis] = biggestPoint;
      bumpoutPoints.dragPoint[axis] = smallestPoint + dragPointMargin
    } else {
      point1[axis] -= diff;
      point2[axis] -= diff;
      bumpoutPoints.dragPoint[axis] -= diff;
      lengthMidPoint = line.overlay.getMidpoint();
      line.overlay.setMidpointOffset(lengthMidPoint.xOffset  - diff, lengthMidPoint.yOffset - diff);
    }
  }

  function move23Point(point1, point2, axis, diff) {
    // Check for intersection with all lines in the parent shape
    point1[axis] -= diff;
    point2[axis] -= diff;
    let intersects = line.getParent().getLines().some(parentLine => {
      // Don't check against itself
      if (parentLine === line) return false;

      // Check if bumpoutPoints {from: point1, to: point2} line would intersect this parent line
      return getIntersectCordsBetweenLines(
        { x: parentLine.from.x, y: parentLine.from.y },
        { x: parentLine.to.x, y: parentLine.to.y },
        { x: bumpoutPoints.point1.x, y: bumpoutPoints.point1.y },
        { x: bumpoutPoints.point2.x, y: bumpoutPoints.point2.y }
      );
    });

    // Only move points if no intersection detected
    if (!intersects) {
      let lengthMidPoint = line.overlay.getMidpoint();
      bumpoutPoints.dragPoint[axis] -= diff;
      line.overlay.setMidpointOffset(lengthMidPoint.xOffset  - diff, lengthMidPoint.yOffset - diff);
    } else {
      // rollback points if intersection was found
      point1[axis] += diff;
      point2[axis] += diff;
    }
  }

  function getMousePosPointDiff(diff, point, mousePos, sameOrientation = false) {
    if (configGlobal.measureUnit === "Metric") {
      var offset = 0;
      switch(line.getOrientation()) {
        case orientation.HORIZONTAL:
          offset = sameOrientation ? mousePos.x - point.getPointField().x : mousePos.y - point.getPointField().y;
          break;
        case orientation.VERTICAL:
          offset = sameOrientation? mousePos.y - point.getPointField().y : mousePos.x - point.getPointField().x;
          break;
        case orientation.NORTHWEST:
        case orientation.SOUTHEAST:
          break;
        case orientation.NORTHEAST:
        case orientation.SOUTHWEST:
          break;
      }

      if (-config.movePointOffset < offset && offset < config.movePointOffset) {
        diff = diff / configGlobal.millimetersMultiplier;
      }
    }

    return diff
  }

  //public property getters

  this.getParent = () => { return line; };
  this.getGrandParent = () => {
    const parent = this.getParent();
    if (parent && parent.getParent) {
      return parent.getParent();
    }
    return null
  };
  this.getBumpoutPoints = function() { return bumpoutPoints; };
  this.getBumpoutLines = () => {
    if (bumpoutLines) {
      return bumpoutLines
    }
    return this.createBumpoutLines();
  };
  this.createBumpoutLines = () => {
    const points = this.getBumpoutPoints();
    bumpoutLines = [
      new shapeLine(line.from, points.point1, line.getParent()),
      new shapeLine(points.point1, points.point2, line.getParent()),
      new shapeLine(points.point2, points.point3, line.getParent()),
      new shapeLine(points.point3, points.point4, line.getParent()),
      new shapeLine(points.point4, line.to, line.getParent()),
    ];

    return bumpoutLines
  };
  this.getBumpoutPointCords = function() {
    let bumpoutPointsCords = [];
    for (const bumpoutPointsKey in bumpoutPoints) {
      if (bumpoutPointsKey !== 'dragPoint') {
        bumpoutPointsCords.push(bumpoutPoints[bumpoutPointsKey]);
      }
    }
    return bumpoutPointsCords
  };
  this.getBumpoutTextParameter = function() { return bumpoutTextParameters; };

  this.destroy = function(protect) {
    if (!protect) {
      EventManager.removeEvent(self);
    }
    const reduxState = store.getState();
    store.dispatch(deleteResource(RESOURCE_TYPE.attachedToLine, this.resourceId));
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };

  this.init = (line, importPoints = null, featureId = null, resourceId = null) => {
    setLine(line);
    if (!importPoints) {
      preparePoints();
    }
    this.featureId = featureId
    if (resourceId) {
      this.resourceId = resourceId
    }
    if (!featureId) {
      const bumpoutFeature = getBumpoutFeature();
      const isFeatureExist = Array.isArray(bumpoutFeature)
        && bumpoutFeature.length
        && bumpoutFeature[0].part
        && bumpoutFeature[0].part.dbFeature

      this.featureId = isFeatureExist ? bumpoutFeature[0].part.dbFeature.id : null;
    }
    this.initEvents();

    //points
    bumpoutPoints.point1.init(self);
    bumpoutPoints.point1.layout = 'white-circle';

    bumpoutPoints.point2.init(self);
    bumpoutPoints.point2.layout = 'blank';

    bumpoutPoints.point3.init(self);
    bumpoutPoints.point3.layout = 'blank';

    bumpoutPoints.point4.init(self);
    bumpoutPoints.point4.layout = 'white-circle';

    bumpoutPoints.dragPoint.init(self);
    bumpoutPoints.dragPoint.layout = 'arrow-circle';

    // set line overlay length offset
    if (!importPoints) {
      var xOffset = 0;
      var yOffset = 0;
      var lineDirection = line.getLineDirection();
      switch (lineDirection.orientation) {
        case "horizontal": {
          yOffset = (lineDirection.newDirection === "west" ? config.dragPointMargin - 15 : -config.dragPointMargin + 15);
          break;
        }
        case "vertical": {
          xOffset = (lineDirection.newDirection === "south" ? config.dragPointMargin - 15 : -config.dragPointMargin + 15);
          break;
        }
        // todo rotation
        case "NORTHWEST": { break;}
        case "NORTHEAST": { break;}
        case "SOUTHWEST": { break;}
        case "SOUTHEAST": { break;}
        default:
          break;
      }
      line.overlay.setMidpointOffset(xOffset, yOffset)
    }

    // todo fix bumpout rotation and remove this
    $('.button--angle').addClass('button--disabled');
    /////////////////////////////////////////
  };
  this.initEvents = () => {
    EventManager.addEvent(
      EventManager.events.RENDER,
      self.render,
      self,
      EventManager.priorities.SEGMENT
    );
    //todo priority
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      self,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      self,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      onMouseUp,
      self,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_LEAVE,
      onMouseLeave,
      self,
      EventManager.priorities.OVERALL
    );
  }
  this.deregisterEvents = () => {
    sqftEventManager.removeEvent(this);
    this.isHidden = true;
    for (let i = 0; i < bumpoutPoints.length; i++) {
      bumpoutPoints[i].deregisterEvents();
    }
  };
  this.reInitEvents = () => {
    this.initEvents();
    this.isHidden = false;
    for (let i = 0; i < bumpoutPoints.length; i++) {
      bumpoutPoints[i].reInitEvents();
    }
  };
  this.export = function() {
    return {
      bumpoutPoints : {
        point1: bumpoutPoints.point1.export(),
        point2: bumpoutPoints.point2.export(),
        point3: bumpoutPoints.point3.export(),
        point4: bumpoutPoints.point4.export(),
        dragPoint: bumpoutPoints.dragPoint.export()
      },
      overlay: {
        midpoint: line.overlay.getMidpoint(),
        id: this.id,
        resourceId: this.resourceId
      }
    }
  };
  this.import = (line, bumpoutData) => {
    for (let bumpoutPoint in bumpoutData.bumpoutPoints) {
      bumpoutPoints[bumpoutPoint] = new point();
      bumpoutPoints[bumpoutPoint].import(bumpoutData.bumpoutPoints[bumpoutPoint])
    }
    this.init(line, bumpoutData.bumpoutPoints, bumpoutData.overlay.id, bumpoutData.overlay.resourceId);
  };
  this.getOffset = function() {
    return line.getOffset();
  };
  this.getBumpoutLength = function () {
    var bumpoutDistance = getPointDistance(bumpoutPoints.point1, bumpoutPoints.point2);

    return measureDistanceToInches(bumpoutDistance);
  };
  this.getBumpoutTotalHeight = function () {
    var bumpoutDistance = getPointDistance(bumpoutPoints.point1, bumpoutPoints.point2);

    return measureDistanceToInches(bumpoutDistance * 2);
  };
  this.getBumpoutTotalArea = () => {
    if (this.bumpoutInOrOut() === 'in') {
      return {
        inches: 0,
        millimeters: 0
      }
    }

    var lineLengthInches = line.getLineLength(),
      lineLengthMm = line.getLineLengthMm(),

      bumpoutLength = this.getBumpoutLength(),
      bumpoutLengthInches = line.addDecimalToLength(bumpoutLength),
      bumpoutLengthMM = bumpoutLength.millimeters;

    return {
      inches : lineLengthInches * bumpoutLengthInches,
      millimeters : lineLengthMm * bumpoutLengthMM
    }
  };

  this.isHoveringRect = () => { return state.isHoveringRect };

  this.moveBumpout = (dx = 0, dy = 0) => {
    for (let bumpoutPoint in bumpoutPoints) {
      if (bumpoutPoints.hasOwnProperty(bumpoutPoint)) {
        bumpoutPoints[bumpoutPoint].x -= dx;
        bumpoutPoints[bumpoutPoint].y -= dy;
      }
    }
  };

  this.moveLineWithMouse = function(mousePos) {
    let scale = workspace.getScale();
    let xDiff = (state.mouseDownPosition.x - mousePos.x) / scale;
    let yDiff = (state.mouseDownPosition.y - mousePos.y) / scale;

    yDiff = getMousePosPointDiff(yDiff, bumpoutPoints.dragPoint, mousePos);
    xDiff = getMousePosPointDiff(xDiff, bumpoutPoints.dragPoint, mousePos);

    this.moveLine(xDiff, yDiff);

    state.mouseDownPosition.y = mousePos.y;
    state.mouseDownPosition.x = mousePos.x;
  };

  this.isBumpoutPointMoving = () => { return state.mouseDown};
  this.moveLine = function(xDiff, yDiff) {
    if (SqftStore.isRegularMode() && shouldResetSlabModePopupOnPointMoveBeDisplayed(this.getGrandParent())) {
      renderResetSeamPopup(this.getGrandParent())
    }

    var o = line.getOrientation();

    if (o === orientation.VERTICAL) {
      move23Point(bumpoutPoints.point2, bumpoutPoints.point3, 'x', xDiff);
      void movePointOutOrStop
      //movePointOutOrStop(bumpoutPoints.point2, bumpoutPoints.point3, 'x', xDiff, line.getBiggestXPoint().x, line.getSmallestXPoint().x, false);
    } else if (o === orientation.HORIZONTAL) {
      // let distance = line.getSmallestYPoint().y;
      // const closetParallelLineAndPoint = findClosestIntersectingPointAndLine(line, line.getParent().getLines());
      // if (closetParallelLineAndPoint) {
      //   const midPoint = getMidPoint(line.from, line.to);
      //   distance = getPointDistance(midPoint, closetParallelLineAndPoint.point);
      // }
      // movePointOutOrStop(bumpoutPoints.point2, bumpoutPoints.point3, 'y', yDiff, distance, distance, false);

      move23Point(bumpoutPoints.point2, bumpoutPoints.point3, 'y', yDiff);
    } else {
      //todo
      // const nextLine = parent.getNextLine(self);
      // const prevLine = parent.getPrevLine(self);
      // moveDiagonalLine(self, nextLine, prevLine, state.movePointDistance, yDiff, o);
    }

    const state = store.getState();
    const updateCalculations = state.sqftState.updateCalculations;

    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };

  this.movePointWithMouse = function(mousePos, point1, point2, stopPoint) {
    var scale = workspace.getScale();
    var xDiff = (state.mouseDownPosition.x - mousePos.x) / scale;
    var yDiff = (state.mouseDownPosition.y - mousePos.y) / scale;

    yDiff = getMousePosPointDiff(yDiff, point1, mousePos, true);
    xDiff = getMousePosPointDiff(xDiff, point1, mousePos, true);

    this.movePoint(xDiff, yDiff, point1, point2, stopPoint);

    state.mouseDownPosition.y = mousePos.y;
    state.mouseDownPosition.x = mousePos.x;
  };

  this.resizeBumpoutPart = function(value, hoveredText) {
    let yDiff = 0,
      xDiff = 0,
      pointDistance = getPointDistance(hoveredText.points.point1, hoveredText.points.point2),
      lineDirection = line.getLineDirection();

    switch(line.getOrientation()) {
      case orientation.HORIZONTAL:

        switch (hoveredText.part) {
          case "lengthFrom1":
            xDiff = lineDirection.newDirection === "west" ? value - pointDistance: -value + pointDistance;
            this.movePoint(xDiff, yDiff, bumpoutPoints.point1, bumpoutPoints.point2, bumpoutPoints.point4);
            break;
          case "length4to":
            xDiff = lineDirection.newDirection === "west" ? -value + pointDistance : value - pointDistance;
            this.movePoint(xDiff, yDiff, bumpoutPoints.point3, bumpoutPoints.point4, bumpoutPoints.point1);
            break;
          case "length14":
            xDiff = lineDirection.newDirection === "west" ? -value + pointDistance: value - pointDistance;
            this.movePoint(xDiff / 2, yDiff, bumpoutPoints.point1, bumpoutPoints.point2, bumpoutPoints.point4);

            xDiff = lineDirection.newDirection === "west" ? value - pointDistance: -value + pointDistance;
            this.movePoint(xDiff / 2, yDiff, bumpoutPoints.point3, bumpoutPoints.point4, bumpoutPoints.point1);

            break;
          case "length34":
            pointDistance = this.bumpoutInOrOut() === "in" ? -pointDistance : pointDistance;
            yDiff = lineDirection.newDirection === "west" ? -value + pointDistance: value - pointDistance;
            this.moveLine(xDiff, yDiff);
            break;
        }
        break;
      case orientation.VERTICAL:
        switch (hoveredText.part) {
          case "lengthFrom1":
            yDiff = lineDirection.newDirection === "south" ? -value + pointDistance: value - pointDistance;
            this.movePoint(xDiff, yDiff, bumpoutPoints.point1, bumpoutPoints.point2, bumpoutPoints.point4);
            break;
          case "length4to":
            yDiff = lineDirection.newDirection === "south" ? value - pointDistance : -value + pointDistance;
            this.movePoint(xDiff, yDiff, bumpoutPoints.point3, bumpoutPoints.point4, bumpoutPoints.point1);
            break;
          case "length14":
            yDiff = lineDirection.newDirection === "south" ? -value + pointDistance: value - pointDistance;
            this.movePoint(xDiff, yDiff / 2, bumpoutPoints.point3, bumpoutPoints.point4, bumpoutPoints.point1);

            yDiff = lineDirection.newDirection === "south" ? value - pointDistance : -value + pointDistance;
            this.movePoint(xDiff, yDiff / 2, bumpoutPoints.point1, bumpoutPoints.point2, bumpoutPoints.point4);
            break;
          case "length34":
            pointDistance = this.bumpoutInOrOut() === "in" ? -pointDistance : pointDistance;
            xDiff = lineDirection.newDirection === "south" ? -value + pointDistance: value - pointDistance;
            this.moveLine(xDiff, yDiff);
            break;
        }
        break;
      case orientation.NORTHWEST:
      case orientation.SOUTHEAST:
        break;
      case orientation.NORTHEAST:
      case orientation.SOUTHWEST:
        break;
    }
  };

  this.movePoint = function(xDiff, yDiff, point1, point2, stopPoint) {
    if (SqftStore.isRegularMode() && shouldResetSlabModePopupOnPointMoveBeDisplayed(this.getGrandParent())) {
      renderResetSeamPopup(this.getGrandParent())
    }
    let o = line.getOrientation(),
      midPoint,
      dragPointMargin,
      lineDirection = line.getLineDirection(),
      toCornerLength = line.to.getArcLength() || line.get45CornerLegDistance(),
      prevLine = line.getParent().getPrevLine(line),
      fromCornerLength = prevLine.to.getArcLength() || prevLine.get45CornerLegDistance(),
      toCornerMargin = 0,
      fromCornerMargin = 0;

    if (o === orientation.VERTICAL) {
      midPoint = getMidPoint(bumpoutPoints.point2, bumpoutPoints.point3);
      dragPointMargin = lineDirection.newDirection === "north" ? -config.dragPointMargin : +config.dragPointMargin;
      bumpoutPoints.dragPoint.x = midPoint.x + dragPointMargin;
      bumpoutPoints.dragPoint.y = midPoint.y;
      toCornerMargin = lineDirection.newDirection === "north" ? -fromCornerLength : -toCornerLength;
      fromCornerMargin = lineDirection.newDirection === "north" ? +toCornerLength : +fromCornerLength;

      // stop point on overline move
      movePointInOrStop(
        point1, point2, 'y', yDiff,
        line.getBiggestYPoint().y + toCornerMargin,
        line.getSmallestYPoint().y + fromCornerMargin,
        stopPoint
      );
    } else if (o === orientation.HORIZONTAL) {
      midPoint = getMidPoint(bumpoutPoints.point2, bumpoutPoints.point3);
      dragPointMargin = lineDirection.newDirection === "east" ? -config.dragPointMargin : +config.dragPointMargin;
      bumpoutPoints.dragPoint.x = midPoint.x;
      bumpoutPoints.dragPoint.y = midPoint.y + dragPointMargin;
      toCornerMargin = lineDirection.newDirection === "east" ? -toCornerLength : -fromCornerLength;
      fromCornerMargin = lineDirection.newDirection === "east" ? +fromCornerLength : +toCornerLength;

      // stop point on overline move
      movePointInOrStop(
        point1, point2, 'x', xDiff,
        line.getBiggestXPoint().x + toCornerMargin,
        line.getSmallestXPoint().x + fromCornerMargin,
        stopPoint
      );
    } else {
      //todo rotation
      // const nextLine = parent.getNextLine(self);
      // const prevLine = parent.getPrevLine(self);
      // moveDiagonalLine(self, nextLine, prevLine, state.movePointDistance, yDiff, o);
      // state.mouseDownPosition = mousePos;
    }


    // self.from = lockPointToCanvas(self.from);  //  removed locking because of this issue http://jira.mozidev.com/browse/QC-802
    // self.to = lockPointToCanvas(self.to);
  };



  // Define a function to determine if the bumpout is in or out.
  this.bumpoutInOrOut = (pointA = line.from, pointB = line.to, dragPoint = bumpoutPoints.point2) => {
    // Calculate vectors.
    const vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
    const vectorADrag = { x: dragPoint.x - pointA.x, y: dragPoint.y - pointA.y };

    // Calculate the cross product of vectorAB and vectorADrag.
    const crossProdZ = crossProduct2D(vectorAB, vectorADrag);

    // Determine if the bumpout is in or out based on the cross product.
    if (crossProdZ > 0) {
      // Positive Z component indicates an outward bumpout (peak).
      return 'in';
    } else {
      // Negative Z component indicates an inward bumpout (valley).
      return 'out';
    }
  }

  this.drawBumpoutRect = (ctx) => {
    var point1 = line.calculateRenderPosition(bumpoutPoints.point1),
      point2 = line.calculateRenderPosition(bumpoutPoints.point2),
      point3 = line.calculateRenderPosition(bumpoutPoints.point3),
      point4 = line.calculateRenderPosition(bumpoutPoints.point4);
      //bumpoutHeight = getPointDistance(bumpoutPoints.point1, bumpoutPoints.point2),
      //bumpoutLength = getPointDistance(bumpoutPoints.point1, bumpoutPoints.point4);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(point1.x, point1.y);
    ctx.lineTo(point2.x, point2.y);
    ctx.lineTo(point3.x, point3.y);
    ctx.lineTo(point4.x, point4.y);
    ctx.closePath();
    ctx.fillStyle = deleteFillStyle;
    ctx.stroke();
    ctx.fill();
    ctx.restore();
  };

  this.render = function(ctx) {
    if (isDisabledInPopupShouldBeHidden() && isDisabledInPopupWithParents(line)) {
      return
    }
    renderTopBlueLine(ctx);
    renderRuler(ctx);
    renderMeasurements(ctx);
  };

  //blue line between middle points
  function renderTopBlueLine(ctx) {
    var renderFrom = line.calculateRenderPosition(bumpoutPoints.point2),
      renderTo = line.calculateRenderPosition(bumpoutPoints.point3);

    ctx.beginPath();
    ctx.moveTo(renderFrom.x, renderFrom.y);
    ctx.lineTo(renderTo.x, renderTo.y);
    ctx.lineWidth = 8;
    ctx.strokeStyle = config.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  }

  const renderRuler = (ctx) => {
    let
      //toCornerLength = line.to.getAngle() || line.to.getArcLength(),
      //prevLine = line.getParent().getPrevLine(line),
      //fromCornerLength = prevLine.to.getAngle() || prevLine.to.getArcLength(),
      lineDirection = line.getLineDirection(),
      renderTo  = line.calculateRenderPosition(line.to),
      renderFrom = line.calculateRenderPosition(line.from),
      point1 = line.calculateRenderPosition(bumpoutPoints.point1),
      point4 = line.calculateRenderPosition(bumpoutPoints.point4),
      xMargin = 0,
      yMargin = 0,
      xOffset = 3,
      yOffset = 3,
      bumpoutXOffset = 0,
      bumpoutYOffset = 0,
      scale = configGlobal.scale,
      pointDistance34 = getPointDistance(bumpoutPoints.point3, bumpoutPoints.point4);

    switch (lineDirection.orientation) {
      case "horizontal": {
        yMargin = (lineDirection.newDirection === "west" ? config.rulerMargin : -config.rulerMargin);
        bumpoutYOffset = (lineDirection.newDirection === "west" ? pointDistance34 * scale : -(pointDistance34 * scale));
        // we need to change sign of bumpoutYOffset if it is bumoutIN
        if (this.bumpoutInOrOut(line.from, line.to, bumpoutPoints.point2) === "in") {
          bumpoutYOffset = -bumpoutYOffset
        }
        xOffset = (lineDirection.newDirection === "west") ? -xOffset : xOffset;
        yOffset = 0;
        break;
      }
      case "vertical": {
        xMargin = (lineDirection.newDirection === "south" ? config.rulerMargin: -config.rulerMargin);
        bumpoutXOffset = (lineDirection.newDirection === "south" ? pointDistance34 * scale: -(pointDistance34 * scale));
        // we need to change sign of bumpoutYOffset if it is bumoutIN
        if (this.bumpoutInOrOut(line.from, line.to, bumpoutPoints.point2) === "in") {
          bumpoutXOffset = -bumpoutXOffset
        }
        yOffset = (lineDirection.newDirection === "south") ? yOffset : -yOffset;
        xOffset = 0;
        break;
      }
      // todo rotation
      case "NORTHWEST": { break;}
      case "NORTHEAST": { break;}
      case "SOUTHWEST": { break;}
      case "SOUTHEAST": { break;}
      default:
        break;
    }

    ctx.beginPath();
    drawArrow(ctx, renderFrom.x + xMargin, renderFrom.y + yMargin, point1.x + xMargin, point1.y + yMargin);
    drawArrow( ctx,
      point1.x + xMargin + xOffset + bumpoutXOffset,
      point1.y + yMargin + yOffset + bumpoutYOffset,
      point4.x + xMargin - xOffset + bumpoutXOffset,
      point4.y + yMargin - yOffset + bumpoutYOffset
    );
    drawArrow(ctx, point4.x + xMargin, point4.y + yMargin, renderTo.x + xMargin, renderTo.y + yMargin);
    ctx.lineWidth = 1;
    ctx.strokeStyle = config.lineTextColor;
    ctx.stroke();
    ctx.closePath();
  }

  const renderMeasurements = (ctx) => {
    var scale = configGlobal.scale,
      fontSize = getFontsizeSmall(),
      font = (fontSize).toString() + "px " + Config.activeFontBold,
      lineDirection = line.getLineDirection(),
      lineTextColor = config.lineTextColor,
      xOffset = 0,
      yOffset = 0;

    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = lineTextColor;

    //todo rotation
    // const rotateAnglePart = line.from.rotateAnglePart;
    // const rotatedAngleValue = line.from.rotateAnglePart ? line.from.rotateAnglePart.rotatedAngleValue : 0;
    // const parent = line.getParent();
    // let moveFrom, moveTo, prevLine, nextLine, prevParallelLine, nextParallelLine;
    // if (lineDirection.orientation !== "horizontal" && lineDirection.orientation !== "vertical") {
    //   prevLine = parent.getPrevLine(line);
    //   nextLine = parent.getNextLine(line);
    //   prevParallelLine = parent.getPrevLine(prevLine);
    //   nextParallelLine = parent.getNextLine(nextLine);
    // }

    switch (lineDirection.orientation) {
      case "horizontal": {
        // renderTextBetweenPoints34
        xOffset = (lineDirection.newDirection === "west" ? -45 : 45);
        yOffset = (lineDirection.newDirection === "west" ? 60 : -60);
        renderHorizontalText(bumpoutPoints.point3, bumpoutPoints.point4, xOffset, yOffset, fontSize, ctx, bumpoutTextParameters.length34, 'length34');

        //renderTextBetweenPoints14
        let pointDistance34 = getPointDistance(bumpoutPoints.point3, bumpoutPoints.point4);
        // we need to change sign of bumpoutYOffset if it is bumoutIN
        if (this.bumpoutInOrOut(line.from, line.to, bumpoutPoints.point2) === "in") {
          pointDistance34 = -pointDistance34
        }
        xOffset = (lineDirection.newDirection === "west" ? -10 : 10);
        yOffset = (lineDirection.newDirection === "west" ? 45 + (pointDistance34 * scale) : -45  - (pointDistance34 * scale));
        renderHorizontalText(bumpoutPoints.point1, bumpoutPoints.point4, xOffset, yOffset, fontSize, ctx, bumpoutTextParameters.length14, 'length14');

        // renderTextBetweenPointsFrom1
        xOffset = (lineDirection.newDirection === "west" ? 40 : -30);
        yOffset = (lineDirection.newDirection === "west" ? 45 : -45);
        renderHorizontalText(line.from, bumpoutPoints.point1, xOffset, yOffset, fontSize, ctx, bumpoutTextParameters.lengthFrom1, 'lengthFrom1');

        //renderTextBetweenPoints4To
        xOffset = (lineDirection.newDirection === "west" ? -40 : 40);
        yOffset = (lineDirection.newDirection === "west" ? 45 : -45);
        renderHorizontalText(bumpoutPoints.point4, line.to, xOffset, yOffset, fontSize, ctx, bumpoutTextParameters.length4to, 'length4to');

        //ctx.wrapText(dstring, state.midPoint.x, state.midPoint.y, medgeText, fontSize);
        break;
      }
      case "vertical": {
        //renderTextBetweenPoints34
        yOffset = (lineDirection.newDirection === "south" ? 25 : -25 );
        xOffset = (lineDirection.newDirection === "south" ? 80 : -80 );

        renderHorizontalText(bumpoutPoints.point3, bumpoutPoints.point4, xOffset, yOffset, fontSize, ctx, bumpoutTextParameters.length34, 'length34');

        xOffset = (lineDirection.newDirection === "south" ? 35 : -35);
        yOffset = (lineDirection.newDirection === "south" ? -45 : 30 );

        // renderTextBetweenPointsFrom1
        renderRotatedText(ctx, line.from, bumpoutPoints.point1, fontSize, xOffset, yOffset, bumpoutTextParameters.lengthFrom1, 'lengthFrom1');

        yOffset = (lineDirection.newDirection === "south" ? 30 : -45 );
        // renderTextBetweenPoints4To
        renderRotatedText(ctx, bumpoutPoints.point4, line.to, fontSize, xOffset, yOffset, bumpoutTextParameters.length4to, 'length4to');

        // renderTextBetweenPoints14
        let pointDistance34 = getPointDistance(bumpoutPoints.point3, bumpoutPoints.point4);
        // we need to change sign of bumpoutYOffset if it is bumoutIN
        if (this.bumpoutInOrOut(line.from, line.to, bumpoutPoints.point2) === "in") {
          pointDistance34 = -pointDistance34
        }
        xOffset = (lineDirection.newDirection === "south" ? 35 + (pointDistance34 * scale) : -35 - (pointDistance34 * scale));
        yOffset = 0;
        renderRotatedText(ctx, bumpoutPoints.point1, bumpoutPoints.point4, fontSize, xOffset, yOffset, bumpoutTextParameters.length14, 'length14');

        break;
      }
      //TODO rotation
      case "NORTHWEST": {
        break;
      }
      case "NORTHEAST":  {
        break;
      }
      case "SOUTHWEST": {
        break;
      }
      case "SOUTHEAST": {
        break;
      }
      default:
        break;
    }
  }

  // private functions
  function renderHorizontalText(point1, point2, xOffset, yOffset, fontSize, ctx, bumpoutTextParameter, part) {
    let scale = configGlobal.scale,
      midPoint = getMidPoint(point1, point2),
      offset = line.getOffset(),
      pointsDistance = getPointDistance(point1, point2),
      renderText = configGlobal.measureUnit === "Metric" ? distanceToMillimeters(pointsDistance.toString()) : distanceToInches(pointsDistance.toString()),
      mText = ctx.measureText(renderText);

    midPoint.x = midPoint.x * scale + offset.x;
    midPoint.y = midPoint.y * scale + offset.y + fontSize / 2;
    ctx.wrapText(renderText, midPoint.x + xOffset, midPoint.y + yOffset, mText, fontSize);

    bumpoutTextParameter.area = getTextPointsArea(midPoint.x + xOffset, midPoint.y + yOffset, mText, orientation.HORIZONTAL);
    bumpoutTextParameter.midPoint = {x: midPoint.x + xOffset, y: midPoint.y + yOffset};
    bumpoutTextParameter.pointsDistance = pointsDistance;
    bumpoutTextParameter.points = { point1: point1, point2: point2 };
    bumpoutTextParameter.part = part;
    bumpoutTextParameter.orientation = orientation.HORIZONTAL;
  }

  function renderRotatedText(ctx, point1, point2, fontSize, xOffset, yOffset, bumpoutTextParameter, part) {
    let scale = configGlobal.scale,
      midPoint = getMidPoint(point1, point2),
      offset = line.getOffset(),
      pointsDistance = getPointDistance(point1, point2),
      textToRender = configGlobal.measureUnit === "Metric" ? distanceToMillimeters(pointsDistance.toString()) : distanceToInches(pointsDistance.toString()),
      mText = ctx.measureText(textToRender),
      lineDirection = line.getLineDirection();

    midPoint.x = midPoint.x * scale + offset.x;
    midPoint.y = midPoint.y * scale + offset.y + fontSize / 2;

    ctx.save();
    ctx.translate(
      lineDirection.newDirection === "south" ? midPoint.x + xOffset : midPoint.x + xOffset,
      lineDirection.newDirection === "south" ? midPoint.y + yOffset : midPoint.y + yOffset
    );
    ctx.rotate(lineDirection.newDirection === "south" ? Math.PI / 2 : -Math.PI / 2);
    ctx.wrapText(textToRender, 0, 0, ctx.measureText(textToRender), fontSize);
    ctx.restore();

    bumpoutTextParameter.area = getTextPointsArea(midPoint.x + xOffset, midPoint.y + yOffset, mText, orientation.VERTICAL);
    bumpoutTextParameter.midPoint = {x: midPoint.x + xOffset, y: midPoint.y + yOffset};
    bumpoutTextParameter.pointsDistance = pointsDistance;
    bumpoutTextParameter.points = { point1: point1, point2: point2 };
    bumpoutTextParameter.part = part;
    bumpoutTextParameter.orientation = orientation.VERTICAL;
  }

  function drawArrow(context, fromX, fromY, toX, toY) {
    var headLen = 10; // length of head in pixels
    var dx = toX - fromX;
    var dy = toY - fromY;
    var angle = Math.atan2(dy, dx);

    context.moveTo(fromX, fromY);
    context.lineTo(toX, toY);
    context.lineTo(toX - headLen * Math.cos(angle - Math.PI / 6), toY - headLen * Math.sin(angle - Math.PI / 6));
    context.moveTo(toX, toY);
    context.lineTo(toX - headLen * Math.cos(angle + Math.PI / 6), toY - headLen * Math.sin(angle + Math.PI / 6));

    context.moveTo(fromX, fromY);
    context.lineTo(fromX + headLen * Math.cos(angle - Math.PI / 6), fromY + headLen * Math.sin(angle - Math.PI / 6));
    context.moveTo(fromX, fromY);
    context.lineTo(fromX + headLen * Math.cos(angle + Math.PI / 6), fromY + headLen * Math.sin(angle + Math.PI / 6));
  }

  function onMouseMove(mousePos, e) {
    void e;
    state.isHoveredOverText = false;
    state.isHoveringRect = false;

    for (const property in bumpoutTextParameters) {
      if (isMouseOverText(bumpoutTextParameters[property].area, mousePos)) {
        state.isHoveredOverText = true;
        state.hoveredText = bumpoutTextParameters[property];
        break;
      }
    }

    if (isMouseOverRect(mousePos)) {
      state.isHoveringRect = true;
    }

    if (isMouseOverPoint(mousePos, bumpoutPoints.dragPoint)) {
      // todo angle
      // if (workspace.getAllowBumpoutEdges() && !line.from.angleIsChanged && !line.to.angleIsChanged) {

      if (state.mouseDown) {
        self.moveLineWithMouse(mousePos);
      }
      EventManager.releaseStealLock(parent); //TODO Cursor
      EventManager.stealCursor(true, true);
      switch(line.getOrientation()) {
        case orientation.HORIZONTAL:
          EventManager.setCursor("n-resize", self);
          break;
        case orientation.VERTICAL:
          EventManager.setCursor("e-resize", self);
          break;
        case orientation.NORTHWEST:
        case orientation.SOUTHEAST:
          EventManager.setCursor("ne-resize", self);
          break;
        case orientation.NORTHEAST:
        case orientation.SOUTHWEST:
          EventManager.setCursor("nw-resize", self);
          break;
      }

      return state.mouseDown;


      // if (configGlobal.highlight.lines && state.isHoveringPoint) {
      //   EventManager.releaseStealLock(line.parent);
      //   EventManager.stealCursor();
      //   return false;
      // }

    } else if (isMouseOverPoint(mousePos, bumpoutPoints.point1)) {
      // todo angle
      //  if (workspace.getAllowBumpoutEdges() && !line.from.angleIsChanged && !line.to.angleIsChanged) {
      if (state.mouseDown) {
        self.movePointWithMouse(mousePos, bumpoutPoints.point1, bumpoutPoints.point2, bumpoutPoints.point4);
      }
      return state.mouseDown;

    } else if (isMouseOverPoint(mousePos, bumpoutPoints.point4)) {
      if (state.mouseDown) {
        self.movePointWithMouse(mousePos, bumpoutPoints.point4, bumpoutPoints.point3, bumpoutPoints.point1);
      }
      return state.mouseDown;

    } else if (state.isHoveredOverText) {
      EventManager.stealCursor();
      EventManager.setCursor((state.hoveredText.orientation === orientation.HORIZONTAL) ? "text" : "text-vertical", self);

    } else {
      EventManager.resetCursor(self);
      return false;
    }

    // if (workspace.getHoverShape() !== parent) {
    //   state.isHoveringPoint = false;
    // }

  }

  function isMouseOverPoint(mousePos, point) {
    state.isHoveringPoint = !!point.isOverPointField();
    // console.log("point", point.id);
    // console.log("state.hoveredPoint", state.hoveredPoint.id);
    // console.log("mousePos", state.isHoveringPoint);
    return state.isHoveringPoint || state.mouseDown && state.hoveredPoint && point.id === state.hoveredPoint.id;
  }

  function isMouseOverText(pointArea, mousePos) {
    return pnpolyArray(pointArea, mousePos);
  }

  function isMouseOverRect(mousePos) {
    let point1 = line.calculateRenderPosition(bumpoutPoints.point1),
      point2 = line.calculateRenderPosition(bumpoutPoints.point2),
      point3 = line.calculateRenderPosition(bumpoutPoints.point3),
      point4 = line.calculateRenderPosition(bumpoutPoints.point4);

    let pointArea = [
      [point1.x, point1.y],
      [point2.x, point2.y],
      [point3.x, point3.y],
      [point4.x, point4.y]
    ];

    return pnpolyArray(pointArea, mousePos);
  }

  function getTextPointsArea(x, y, mtext, textOrientation) {
    const lineDirection = line.getLineDirection();
    let pointsArray = [];
    if (textOrientation === orientation.HORIZONTAL) {
      pointsArray = [
        [x - Math.ceil10(mtext.width ,-2)/2 - 10, y - 15],
        [x + Math.ceil10(mtext.width ,-2)/2 + 10, y - 15],
        [x + Math.ceil10(mtext.width ,-2)/2 + 10, y + 10],
        [x - Math.ceil10(mtext.width ,-2)/2 - 10, y + 10],
      ]
    } else if (textOrientation === orientation.VERTICAL) {
      if (lineDirection.newDirection === "south") {
        pointsArray = [
          [x + 25, y - Math.ceil10(mtext.width ,-2)/2 - 10],
          [x + 5, y - Math.ceil10(mtext.width ,-2)/2 - 10],
          [x + 5, y + Math.ceil10(mtext.width ,-2)/2 - 5],
          [x + 25, y + Math.ceil10(mtext.width ,-2)/2 - 5],
        ];
      } else if (lineDirection.newDirection === "north") {
        pointsArray = [
          [x - 25, y - Math.ceil10(mtext.width ,-2)/2 - 10],
          [x - 5, y - Math.ceil10(mtext.width ,-2)/2 - 10],
          [x - 5, y + Math.ceil10(mtext.width ,-2)/2 + 5],
          [x - 25, y + Math.ceil10(mtext.width ,-2)/2 + 5],
        ];
      }
    } else {
      // debugger;//eslint-disable-line
    }

    return pointsArray;
  }

  function onMouseUp(mousePos, e) {
    void mousePos;
    void e;
    if (state.mouseDown) {
      state.mouseDown = false;
      state.mouseDownPosition = null;
    }
  }

  function onMouseDown(mousePos, e) {
    void e;
    if (state.isHoveringPoint) {
      state.mouseDown = true;
      state.mouseDownPosition = mousePos;
      for (const point in bumpoutPoints) {
        if (bumpoutPoints[point].isOverPointField(mousePos)) {
          state.hoveredPoint = bumpoutPoints[point];
        }
      }
      return true;
    }

    if (state.isHoveredOverText && !document.querySelector(".line-input")) {
      window.lineInputFocused = true;
      EventManager.stealCursor();

      const maxLength = Math.round(getMaxResizeWidth(line) * configGlobal.getMeasureMultiplier());
      const fontSize = getFontsize();
      const parent = line.getParent();
      const nextLine = parent.getNextLine(line);
      const minValue = -nextLine.getLineDistance();
      const inputPosition = { x: state.hoveredText.midPoint.x, y: state.hoveredText.midPoint.y };

      // Set orientation and position adjustments based on line direction
      let inputClass = "line-input";
      if (state.hoveredText.orientation === orientation.HORIZONTAL) {
        inputClass = "line-input";
      } else if (state.hoveredText.orientation === orientation.VERTICAL) {
        const lineDirection = line.getLineDirection();
        if (lineDirection.newDirection === "south") {
          inputClass = "line-input line-input--vertical-rotated";
          inputPosition.x -= fontSize;
        } else {
          inputClass = "line-input line-input--vertical";
          inputPosition.x += fontSize;
        }
      }

      const inputValue = self.bumpoutInOrOut() === "in"
        ? -Math.round(state.hoveredText.pointsDistance * configGlobal.getMeasureMultiplier())
        : Math.round(state.hoveredText.pointsDistance * configGlobal.getMeasureMultiplier());

      const hoveredText = state.hoveredText;
      // Create adjustable input
      const inputWrapper = createAdjustableInput({
        position: inputPosition,
        initialValue: inputValue.toString(),
        min: minValue,
        max: maxLength,
        orientation: inputClass.includes("vertical") ? "vertical" : "horizontal",
        onChange: (value) => {
          // if (sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
          //   value = mmToInches(value);
          // }
          let scaledValue = Math.round10(value / configGlobal.getMeasureMultiplier(), -2);
          self.resizeBumpoutPart(scaledValue, hoveredText);
        },
        onClose: () => {
          window.lineInputFocused = false;
          EventManager.removeEvent({ name: 'lineInput' });
        },
        step: 1,
      });

      // Append the input wrapper to the DOM
      document.querySelector(".sqft-main-grid").appendChild(inputWrapper);
      // Focus and select input on creation
      const input = inputWrapper.querySelector(".line-input-field");
      input.focus();

      return false;
    }

    return false;
  }

  function onMouseLeave() {
    state.isHoveringPoint = false;
    state.mouseDown = false;
    state.hoveredPoint = null;
    state.isHoveredOverText = false;
    state.hoveredText = {};
  }
}
